<template>
  <loading-container :state="state" i18nErrorMessage="views.legalEntities.errorMessage">
  <div v-if="!notFound">
   <!-- breadcrumbs -->
    <div class="container-fluid breadcrumbs d-none d-md-block">
      <div class="container">
        <div class="row"><div class="col-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a :href="langMain">{{ $t('detailviews.home') }}</a></li>
            <li class="breadcrumb-item"><router-link :to="'/'" >{{ $t('detailviews.counselingCenters') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('detailviews.legalEntities') }}: {{ legalEntity.name }}</li>
          </ol>
        </nav>
        </div></div>
      </div>
    </div>
    <!-- breadcrumbs END -->

  <main id="main" class="">

    <div class="container px-xs-0 pt-2 pt-sm-2 pt-md-0">

      <div class="row">
        <div class="col-12">
          <!-- <button role="button" class="btn btn-link btn-back" @click="$router.back()" v-if="routerbacklink === 'y'" :title="$t('detailviews.backLinkCC')">{{ $t('detailviews.backLinkCC') }} {{}}</button> -->
          <router-link role="button" class="btn btn-link btn-back text-black"
          :to="{
            name: 'counseling-center',
            params: { ccid: routerccid,  backlink: routerbacklink, backlinkCC: 'y', backUrlHistory: backUrlHistory}
          }"
          v-if="routerbacklinkCC === 'y'" :title="$t('detailviews.backLinkCC')">{{ $t('detailviews.backLinkCC') }} </router-link>
        </div>
      </div>

      <div class="row mx-0 beratung">

        <div class="col-12 col-headline bg-white">
          <h1>{{ legalEntity.name }}</h1>
        </div>

        <div class="col-12 col-md-5 col-lg-3 mb-3 mt-3 mt-md-0 bg-white beratung-sidebar">

          <div class="beratung-sidebar-block">
            <div class="mb-2 block-head d-flex align-items-center">
              <div class="icon svg-adresse" aria-hidden="true"></div>
              <h2 class="mb-0">{{ $t('detailviews.address') }}:</h2>
            </div>
            <div class="block-text">
              <p>
                <span v-if="legalEntity.address.streetName">{{ legalEntity.address.streetName }}</span> <span v-if="legalEntity.address.houseNumber">&nbsp;{{ legalEntity.address.houseNumber }}</span><br>
                <span v-if="legalEntity.address.addressSupplement"> {{ legalEntity.address.addressSupplement }} <br></span>
                <span v-if="legalEntity.address.zipCode">{{ legalEntity.address.zipCode }}</span> <span v-if="legalEntity.address.city">&nbsp;{{ legalEntity.address.city }}</span>
              </p>
            </div>
          </div>

          <div class="beratung-sidebar-block">
            <div class="beratung-sidebar-block-kontakt">

              <div class="block-head d-flex align-items-center" v-if="legalEntity.phone">
                <div class="icon svg-tel" aria-hidden="true"></div>
                <a :href="formattedPhoneHref(legalEntity.phone)" rel="noopener" :title="$t('detailviews.telLinkTitle')" class="h3link">{{ legalEntity.phone }}</a>
              </div>

              <div class="block-head d-flex align-items-center" v-if="legalEntity.phone2">
                <div class="icon svg-tel" aria-hidden="true"></div>
                <a :href="formattedPhoneHref(legalEntity.phone2)" rel="noopener" :title="$t('detailviews.telLinkTitle')" class="h3link">{{ legalEntity.phone2 }}</a>
              </div>

              <div class="block-head d-flex align-items-center" v-if="legalEntity.email">
                <div class="icon svg-email" aria-hidden="true"></div>
                <a rel="noopener" :href="formattedEmailHref(legalEntity.email)" :title="$t('detailviews.mailLinkTitle')" class="h3link">{{ $t('detailviews.sendMail')  }}</a>
              </div>

              <div class="block-head d-flex align-items-center" v-if="legalEntity.homepage">
                <div class="icon svg-www" aria-hidden="true"></div>
                <a :href="formattedUrlHref(legalEntity.homepage)" :title="$t('detailviews.urlLinkTitle')" class="h3link extern" rel="noopener nofollow" target="_blank">{{ $t('detailviews.goToUrl')  }}</a>
              </div>
            </div>
          </div>

        </div>

        <div class="col-12 col-md-7 col-lg-9 mb-3 bg-white beratung-content">

          <div lang="de" class="beratung-content-block" v-if="legalEntity.description">
            <h2>{{ $t('detailviews.aboutUs') }}</h2>
            <div v-dompurify-html="legalEntity.description"></div>
          </div><!-- beratung-content-block-->

          <div lang="de" class="beratung-content-block-einrichtungen" v-if="cCenterListe.content">
            <h2>{{ $t('detailviews.centers') }}</h2>

            <ul>
              <li v-for="(center, index) in getSortedCCentersOther()" :key="index">
                <router-link :to="'/counseling-center/'+center.id" >{{center.name}}</router-link>, {{center.address.zipCode}} {{center.address.city}}
              </li>
              <li v-for="(center, index) in getSortedCCentersCourt()" :key="index">
                <router-link :to="'/counseling-center/'+center.id" >{{center.name}}</router-link>, {{center.address.zipCode}} {{center.address.city}}
              </li>
            </ul>
          </div><!-- beratung-content-block-->

        </div>

      </div> <!-- /row beratung -->
    </div> <!-- /container -->


  </main>
  </div>
  <div v-else>
    <main id="main" class="">
      <div class="container px-xs-0">
        <div class="row mx-0 beratung">
          <div class="col-12 col-headline bg-white border-0">
            <h2>$t('detailviews.leNotFound') }}</h2>
          </div>
        </div>
      </div>
    </main>
  </div>
  </loading-container>

</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { FacetResultCounselingCenterSearchResultDto, LegalEntityDto, CounselingCenterSearchResultDto } from '@/generated/openapi/api';
import legalEntityService from '@/services/legalEntityService';

import LoadingContainer from '@/components/structure/LoadingContainer.vue'
import LoadingMixin from '@/mixins/LoadingMixin'
import { LoadingState } from '@/utils/loadingUtils'
import counselingCenterService from '@/services/counselingCenterService';
import { mapActions} from "vuex";

import { sortBy } from "lodash";
import { sanitizeUrl } from '@braintree/sanitize-url';

export default defineComponent({
  name: 'ViewLegalEntity',
  components: {
    LoadingContainer,
  },
  mixins: [
    LoadingMixin
  ],
  data() {
    return {
      legalEntity: {} as LegalEntityDto,
      cCenterListe: {} as FacetResultCounselingCenterSearchResultDto,
      notFound: false,
      courtCCenters: [] as CounselingCenterSearchResultDto[],
      otherCCenters: [] as CounselingCenterSearchResultDto[],
      langMain: 'de',
      routerbacklink: '',
      routerbacklinkCC: '',
      routerccid: '',
      backUrlHistory: ''
    }
  },
  mounted(){

    const tempLang = (document && document.getElementsByTagName('html') && document.getElementsByTagName('html')[0].getAttribute('lang')) || 'de';
    if(tempLang === 'en'){
      this.langMain = '/en/'
    }else{
      this.langMain = '/'
    }

    if( this.$route.params.backlink ){
      if( typeof this.$route.params.backlink === "string"){
        this.routerbacklink = this.$route.params.backlink
      }
    }

    if( this.$route.params.backlinkCC ){
      if( typeof this.$route.params.backlinkCC === "string"){
        this.routerbacklinkCC = this.$route.params.backlinkCC
      }
    }

    if( this.$route.params.ccid ){
      if( typeof this.$route.params.ccid === "string"){
        this.routerccid = this.$route.params.ccid
      }
    }

    if( this.$route.params.backUrlHistory ){
      if( typeof this.$route.params.backUrlHistory === "string"){
        this.backUrlHistory = this.$route.params.backUrlHistory
      }
    }

    this.getAllLookUpValues().then(_ => {
      //this.state = LoadingState.success
    }).catch(_ => {
      this.state = LoadingState.error
    });

    //load data
    this.loadLegalEntity()

    window.scrollTo(0,0);
  },
  methods: {
    ...mapActions(['getAllLookUpValues']),
    setHTMLTitle() {
      let titleOri = document.title;
      if(titleOri.length == 0 || titleOri === ""){
        titleOri = this.$t("detailviews.consultation");
      }
      const title = titleOri.split('-');
      document.title = this.legalEntity.name +" - " + title[title.length -1];
    },
    loadLegalEntity() {
      this.state = LoadingState.loading
      const leId = this.$route.params.leid.toString()
      if(leId) {
        legalEntityService.getLegalEntity(leId).then(legEnt => {
          this.legalEntity = legEnt
          this.notFound = false;
          this.state = LoadingState.success
          this.setHTMLTitle();
          //load cc from le
          counselingCenterService.getCounselingCenters('','',leId).then(result => {
            this.cCenterListe = result
            this.splitCCentersOnCourt();
          });

        }).catch( () =>{
          this.notFound = true;
          this.state = LoadingState.success
        })
      } else {
        this.notFound = true;
        this.state = LoadingState.success
      }
    },
    splitCCentersOnCourt() {
      const allCourts = this.$store.state.rawLookUpValuesCourt;

      if (allCourts && this.cCenterListe.content) {
        this.cCenterListe.content.forEach(center => {
          if (center.lookupValueIds) {
            const value = center.lookupValueIds.some(id => {
              if (allCourts.get(id) == true) {
                return true
              } else {
                return false
              }
            })
            if (value) {
              this.courtCCenters.push(center);
            } else {
              this.otherCCenters.push(center);
            }
          }
        })
      }
    },
    getSortedCCentersOther() {
      return sortBy(this.otherCCenters, [cCenter => cCenter.name.toLowerCase()]);
    },
    getSortedCCentersCourt() {
      return sortBy(this.courtCCenters, [cCenter => cCenter.name.toLowerCase()]);
    },

    formattedUrlHref(url?: string): string | undefined {
      if(url) {
        return sanitizeUrl(url);
      }
      return undefined;
    },

    formattedEmailHref(email?: string): string | undefined {
      if (email) {
        return `mailto:${sanitizeUrl(email)}`;
      }
      return undefined;
    },

    formattedPhoneHref(phone?: string): string | undefined {
      if (phone) {
        return `tel:${this.sanitizePhoneNumber(phone)}`;
      }
      return undefined;
    },

    sanitizePhoneNumber(phone: string): string {
      return phone.replace(/[^0-9+()\-.\s]/g, '');
    }
  }

});
</script>

<style>
  .text-black {
    color: #000;
  }
</style>
